module.exports = __webpack_public_path__ + "static/img/PurpleBubble@2x.334313b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/PurpleBubble@2x.png
// module id = Vr4I
// module chunks = 0